import { fetchCustomFieldsPage } from 'services/CustomFieldService'

import React from 'react'
import { useHistory } from 'react-router-dom'
import Table, { FilterType } from 'components/Shared/Table'
import customFieldModules from 'constants/customFieldModules'
import customFieldTypesOptions from 'constants/customFieldTypesOptions'
import { mapModuleToSectionOptions } from 'components/CustomFields/utils'
import { useTranslation } from 'react-i18next'
import { mapToArray } from 'constants/utils'
import { CUSTOM_FIELDS_CREATE, CUSTOM_FIELDS_EDIT, useAuth } from 'context/auth'

const createColumns = (t) => [
  {
    id: 'deTranslation',
    label: 'customField.table.translation.de',
    path: 'translations.de',
    filterType: FilterType.Text
  },
  {
    id: 'enTranslation',
    label: 'customField.table.translation.en',
    path: 'translations.en',
    filterType: FilterType.Text
  },
  {
    id: 'plTranslation',
    label: 'customField.table.translation.pl',
    path: 'translations.pl',
    filterType: FilterType.Text
  },
  {
    id: 'modules',
    label: 'customField.table.module',
    path: 'module',
    sortable: true,
    filterType: FilterType.Select,
    selectOptions: mapToArray(customFieldModules)
  },
  {
    id: 'section',
    label: 'customField.table.section',
    path: 'section',
    renderFunc: (cell, row) => {
      return t(mapModuleToSectionOptions(row.module)?.find(section => section.value === cell)?.label)
    }
  },
  {
    id: 'types',
    label: 'customField.table.type',
    path: 'type',
    sortable: true,
    filterType: FilterType.Select,
    selectOptions: customFieldTypesOptions
  },
  {
    id: 'isEnabled',
    label: 'customField.table.isEnabled',
    path: 'isEnabled',
    filterType: FilterType.Boolean
  },
  {
    id: 'isVisibleOnPrint',
    label: 'customField.table.isVisibleOnPrint',
    path: 'isVisibleOnPrint',
    filterType: FilterType.Boolean
  },
  {
    id: 'isRequired',
    label: 'customField.table.isRequired',
    path: 'isRequired',
    filterType: FilterType.Boolean
  }
]

export function CustomFieldsTable () {
  const history = useHistory()
  const { t } = useTranslation()
  const { hasAnyPrivileges } = useAuth()

  const addCustomField = () => {
    history.push('/custom-fields/create')
  }

  const editCustomField = (row) => {
    if (!hasAnyPrivileges([CUSTOM_FIELDS_EDIT])) return
    history.push('/custom-fields/edit/' + row.id)
  }

  const addButton = {
    label: 'customField.table.addButtonLabel',
    onClick: addCustomField,
    isClickable: hasAnyPrivileges([CUSTOM_FIELDS_CREATE])
  }

  return (
    <Table title={'customField.table.title'}
           addButton={addButton}
           fetchData={fetchCustomFieldsPage}
           columns={createColumns(t)}
           tableKey={'customFields'}
           onRowClick={editCustomField}
    />
  )
}
